module.exports = __webpack_public_path__ + "img/CS2_section_1_spin_circle_4.316a060d.png";